import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Button } from "reactstrap";
import { Helmet } from "react-helmet";
import Spinner from "../../Spinner/spinner";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { localeEs } from "../../locale/ag-grid-es";
import ModalAutorizacion from "./ModalAutorizacion";
import BreadCrum from "../../breadCrum/breadCrum";
import withTokenCheck from "../../withTokenCheck";

const AppReasignacionHogar = ({ token }) => {
    const [info, setInfo] = useState([]);
    const [loading, setLoading] = useState(true);
    const [modalOpen, setModalOpen] = useState(false);
    const [modalContent, setModalContent] = useState({});
    const [, setModalTittleContent] = useState({});
    const gridApi = useRef(null);
    const etiquetas = [
        "Inicio Lossman",
        "Cambios De Evento",
        "Autorización De Ordenes",
    ];

    const handleModalToggle = () => setModalOpen(!modalOpen);

    useEffect(() => {
        if (token) {
            axios
                .get("/formulario/consulta/no-autorizado", {
                    headers: { Authorization: `Bearer ${token}` },
                })
                .then((response) => {
                    setInfo(response.data);
                    setLoading(false);
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    }, [token]);

    const defaultColDef = {
        sortable: true,
        resizable: true,
        filter: true,
        editable: true,
    };

    function formatPacienteNombre(element) {
        if (!element || !element.data.paciente) {
            return "";
        }
        return (
            element.data.paciente.Nombre1 +
            " " +
            (element.data.paciente.Nombre2
                ? element.data.paciente.Nombre2
                : " ") +
            " " +
            element.data.paciente.Apellido1 +
            " " +
            (element.data.paciente.Apellido2
                ? element.data.paciente.Apellido2
                : " ")
        );
    }

    function formatNumeroDocumento(element) {
        if (!element || !element.data || !element.data.paciente) {
            return "";
        }
        return element.data.paciente.NumeroIdent;
    }

    const columnDefs = [
        {
            field: "id",
            headerName: "Autorizar",
            cellRenderer: (params) => (
                <Button
                    color="secondary"
                    onClick={() => handleEditClick(params.data)}
                >
                    Autorizar
                </Button>
            ),
        },
        {
            field: "Paciente",
            headerName: "paciente",
            cellRenderer: "textCellRenderer",
            valueFormatter: formatPacienteNombre,
        },
        {
            field: "Persona",
            headerName: "Numero de identificación",
            cellRenderer: "textCellRenderer",
            valueFormatter: formatNumeroDocumento,
        },
        {
            field: "NumeroCaso",
            headerName: "Numero de caso",
        },
        {
            field: "FechaInicial",
            headerName: "Fecha Inicial",
        },
        {
            field: "FechaFinal",
            headerName: "Fecha Final",
        },
    ];

    const handleEditClick = (element, content) => {
        console.log(element);
        setModalContent(element);
        setModalTittleContent(content);
        handleModalToggle();
    };

    const handleExportCSV = () => {
        gridApi.current.exportDataAsCsv();
    };

    const onGridReady = (params) => {
        gridApi.current = params.api;
    };

    const handleUpdateTable = () => {
        setLoading(true);
        if (token) {
            axios
                .get("/formulario/consulta/no-autorizado", {
                    headers: { Authorization: `Bearer ${token}` },
                })
                .then((response) => {
                    setInfo(response.data);
                    setLoading(false);
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    };

    return (
        <>
            <Helmet>
                <title>Autorización</title>
            </Helmet>
            <div style={{ position: "relative" }}>
                {loading && <Spinner />}
                <div>
                    <BreadCrum etiquetas={etiquetas} />
                </div>
                <div style={{ opacity: loading ? 0.5 : 1 }}>
                    <div className="container-fluid mt-5">
                        <Button color="success" onClick={handleExportCSV}>
                            Exportar CSV (Excel)
                        </Button>
                        <div
                            className="mt-3"
                            style={{ height: "500px", width: "100%" }}
                        >
                            <div
                                className="ag-theme-alpine"
                                style={{ height: "100%", width: "100%" }}
                            >
                                <AgGridReact
                                    rowData={info}
                                    columnDefs={columnDefs}
                                    defaultColDef={defaultColDef}
                                    pagination={true}
                                    onGridReady={onGridReady}
                                    localeText={localeEs}
                                    paginationPageSize={20}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ModalAutorizacion
                isOpen={modalOpen}
                toggle={handleModalToggle}
                infoModal={modalContent}
                FormId={modalContent.id}
                footer={modalContent.footer}
                token={token}
                updateTable={handleUpdateTable}
            />
        </>
    );
};

export default withTokenCheck(AppReasignacionHogar);
